import { render, staticRenderFns } from "./ChoixAtelier.vue?vue&type=template&id=aaa77718"
import script from "./ChoixAtelier.vue?vue&type=script&lang=js"
export * from "./ChoixAtelier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports